import { Button, Card, Drawer, Image, Popconfirm, Upload, notification } from 'antd';
import React, { useEffect, useState } from 'react';

import { CaretUpOutlined, CloseOutlined, DeleteOutlined, InboxOutlined } from '@ant-design/icons';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';

import path from 'path';
import api from '../../api';
import { NOTIFICATION_TYPE, openNotification } from '../../utils/notification';
import SaveButton from '../Atoms/SaveButton';
import Loading from '../Loading';
import { Frame, ImageContainer } from './styles';
const emptyHandler = (value) => console.warn('UploadButton', value);
const emptyHandlerAsync = (value) => Promise.resolve(value);
const emptyValueHandler = (value) => value;

const store = {
  order: -1,
  collection: []
};

const props = {
  handler: emptyHandler,
  externalDeleteHandler: emptyHandlerAsync,
  externalSortHandler: emptyHandlerAsync,
  transformHandler: emptyValueHandler,
  files: [],
  multiple: false,
  required: false,
  title: '',
  uploadUrl: '',
  downloadUrl: '',
  method: 'post',
  formDataArray: [],
};

const UploadGalley = ({
  handler,
  externalDeleteHandler = null,
  externalSortHandler = null,
  transformHandler = null,
  files = [],
  multiple,
  required,
  title = 'Arquivo',
  uploadUrl,
  downloadUrl,
  method = 'post',
  formDataArray = [],
} = props) => {

  const [fileList, setFileList] = useState([]);
  const [sortedFileList, setSortedFileList] = useState([]);
  const [loading, setLoading] = useState(false);

  const updateMap = (val) => {
    if (val) {
      if (multiple) {
        Array.isArray(val)
          ? store.collection.push(...val)
          : store.collection.push(val);
      }
      else
        store.collection = [val];
    }
    if (transformHandler)
      store.collection = store.collection.map(transformHandler);
    setFileList(store.collection.filter(({ link }) => link).map(linkMap));
  };

  useEffect(() => {
    store.collection = [];
    store.order = files.length;
    updateMap(files)
  }, []);

  function linkMap({ link, ...rest }) {
    const limit = 50;
    let name = rest?.name || path.basename(link);
    if (name.indexOf('___-___') >= 0) {
      name = name.split('___-___')[1];
    }
    if (name.length > limit) {
      name = `...${name.substring(name.length - limit)}`;

    }

    const url = encodeURI(`${downloadUrl}/${link}`);
    return { ...rest, link, name, status: 'done', url };
  }


  const handleUpload = (file) => {

    const formData = new FormData();
    formData.append('file', file);
    formData.append('order', store.order++);
    if (formDataArray !== Array.isArray(formDataArray)) {
      formDataArray.forEach(({ key, value }) => formData.append(key, value));
    }
    setLoading(true);
    api[method](uploadUrl, formData)
      .then(({ data }) => {
        notification.success({ message: `${title} enviado com sucesso!` });
        updateMap(data);
        handler(store.collection);
      })
      .catch(() => {
        notification.error({ message: `Falha ao tentar enviar ${title}!` });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const beforeUpload = (file) => {
    const isImage = file.type.startsWith('image/');
    if (!isImage) {
      openNotification(`${file.name} não é um arquivo de imagem válido`, NOTIFICATION_TYPE.error);
    }
    handleUpload(file);
    return false;
    //return isImage || Upload.LIST_IGNORE;
  };

  const handleRemove = ({ order = undefined, ...rest }) => {

    const handleDelete = externalDeleteHandler
      ? externalDeleteHandler({ order, ...rest })
      : api.delete(`${uploadUrl}/${order}`);
    setLoading(true);
    handleDelete
      .then(() => {
        store.collection = store.collection
          ?.filter(x => x.order !== order)
          ?.map(x => x.order > order ? { ...x, order: x.order - 1 } : x)
          || [];
        store.order = store.collection.length;
        updateMap();
        handler(store.collection);
        notification.success({ message: `${title} removido com sucesso!` });
      })
      .catch(() => {
        notification.error({ message: `Falha ao tentar remover ${title}!` });
      })
      .finally(() => {
        setLoading(false);
      });

  };

  const handleOnDragEnd = (result) => {
    if (!result.destination) return;
    let newItems = Array.from(sortedFileList);
    const [reorderedItem] = newItems.splice(result.source.index, 1);
    newItems.splice(result.destination.index, 0, reorderedItem);
    newItems = newItems.map((item, index) => ({ ...item, order: index }));
    setSortedFileList(newItems);
  };

  const ListItem = ({ imageItem, url, isSimple = false }) => {
    const items = fileList.map((item) => item.url);
    const [index, setIndex] = useState(items.indexOf(url));
    const filename = imageItem?.name || path.basename(url);
    return (
      isSimple
        ?
        <Frame>
          <Image
            fallback="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMIAAADDCAYAAADQvc6UAAABRWlDQ1BJQ0MgUHJvZmlsZQAAKJFjYGASSSwoyGFhYGDIzSspCnJ3UoiIjFJgf8LAwSDCIMogwMCcmFxc4BgQ4ANUwgCjUcG3awyMIPqyLsis7PPOq3QdDFcvjV3jOD1boQVTPQrgSkktTgbSf4A4LbmgqISBgTEFyFYuLykAsTuAbJEioKOA7DkgdjqEvQHEToKwj4DVhAQ5A9k3gGyB5IxEoBmML4BsnSQk8XQkNtReEOBxcfXxUQg1Mjc0dyHgXNJBSWpFCYh2zi+oLMpMzyhRcASGUqqCZ16yno6CkYGRAQMDKMwhqj/fAIcloxgHQqxAjIHBEugw5sUIsSQpBobtQPdLciLEVJYzMPBHMDBsayhILEqEO4DxG0txmrERhM29nYGBddr//5/DGRjYNRkY/l7"
            src={url}
            preview={false}
            prefix={`${url}?x-oss-process=image/blur,r_50,s_50/quality,q_1/resize,m_mfit,h_200,w_200`}
          />
        </Frame>
        :
        <Image.PreviewGroup
          items={items}
          preview={{
            current: index,
            onChange: (currentIndex) => setIndex(currentIndex),
          }}
        >
          <ImageContainer
            extra={
              !isSimple &&
              <Popconfirm
                title="Remover imagem"
                description={`Deseja remover a imagem ${filename}`}
                onConfirm={() => handleRemove(imageItem)}
                okText="Sim"
                cancelText="Não"
              >
                <DeleteOutlined key="delete" />
              </Popconfirm>

            }
            bordered={false}
            hoverable
            cover={<>
              <Image
                fallback="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMIAAADDCAYAAADQvc6UAAABRWlDQ1BJQ0MgUHJvZmlsZQAAKJFjYGASSSwoyGFhYGDIzSspCnJ3UoiIjFJgf8LAwSDCIMogwMCcmFxc4BgQ4ANUwgCjUcG3awyMIPqyLsis7PPOq3QdDFcvjV3jOD1boQVTPQrgSkktTgbSf4A4LbmgqISBgTEFyFYuLykAsTuAbJEioKOA7DkgdjqEvQHEToKwj4DVhAQ5A9k3gGyB5IxEoBmML4BsnSQk8XQkNtReEOBxcfXxUQg1Mjc0dyHgXNJBSWpFCYh2zi+oLMpMzyhRcASGUqqCZ16yno6CkYGRAQMDKMwhqj/fAIcloxgHQqxAjIHBEugw5sUIsSQpBobtQPdLciLEVJYzMPBHMDBsayhILEqEO4DxG0txmrERhM29nYGBddr//5/DGRjYNRkY/l7////39v///y4Dmn+LgeHANwDrkl1AuO+pmgAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAwqADAAQAAAABAAAAwwAAAAD9b/HnAAAHlklEQVR4Ae3dP3PTWBSGcbGzM6GCKqlIBRV0dHRJFarQ0eUT8LH4BnRU0NHR0UEFVdIlFRV7TzRksomPY8uykTk/zewQfKw/9znv4yvJynLv4uLiV2dBoDiBf4qP3/ARuCRABEFAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghgg0Aj8i0JO4OzsrPv69Wv+hi2qPHr0qNvf39+iI97soRIh4f3z58/u7du3SXX7Xt7Z2enevHmzfQe+oSN2apSAPj09TSrb+XKI/f379+08+A0cNRE2ANkupk+ACNPvkSPcAAEibACyXUyfABGm3yNHuAECRNgAZLuYPgEirKlHu7u7XdyytGwHAd8jjNyng4OD7vnz51dbPT8/7z58+NB9+/bt6jU/TI+AGWHEnrx48eJ/EsSmHzx40L18+fLyzxF3ZVMjEyDCiEDjMYZZS5wiPXnyZFbJaxMhQIQRGzHvWR7XCyOCXsOmiDAi1HmPMMQjDpbpEiDCiL358eNHurW/5SnWdIBbXiDCiA38/Pnzrce2YyZ4//59F3ePLNMl4PbpiL2J0L979+7yDtHDhw8vtzzvdGnEXdvUigSIsCLAWavHp/+qM0BcXMd/q25n1vF57TYBp0a3mUzilePj4+7k5KSLb6gt6ydAhPUzXnoPR0dHl79WGTNCfBnn1uvSCJdegQhLI1vvCk+fPu2ePXt2tZOYEV6/fn31dz+shwAR1sP1cqvLntbEN9MxA9xcYjsxS1jWR4AIa2Ibzx0tc44fYX/16lV6NDFLXH+YL32jwiACRBiEbf5KcXoTIsQSpzXx4N28Ja4BQoK7rgXiydbHjx/P25TaQAJEGAguWy0+2Q8PD6/Ki4R8EVl+bzBOnZY95fq9rj9zAkTI2SxdidBHqG9+skdw43borCXO/ZcJdraPWdv22uIEiLA4q7nvvCug8WTqzQveOH26fodo7g6uFe/a17W3+nFBAkRYENRdb1vkkz1CH9cPsVy/jrhr27PqMYvENYNlHAIesRiBYwRy0V+8iXP8+/fvX11Mr7L7ECueb/r48eMqm7FuI2BGWDEG8cm+7G3NEOfmdcTQw4h9/55lhm7DekRYKQPZF2ArbXTAyu4kDYB2YxUzwg0gi/41ztHnfQG26HbGel/crVrm7tNY+/1btkOEAZ2M05r4FB7r9GbAIdxaZYrHdOsgJ/wCEQY0J74TmOKnbxxT9n3FgGGWWsVdowHtjt9Nnvf7yQM2aZU/TIAIAxrw6dOnAWtZZcoEnBpNuTuObWMEiLAx1HY0ZQJEmHJ3HNvGCBBhY6jtaMoEiJB0Z29vL6ls58vxPcO8/zfrdo5qvKO+d3Fx8Wu8zf1dW4p/cPzLly/dtv9Ts/EbcvGAHhHyfBIhZ6NSiIBTo0LNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiEC/wGgKKC4YMA4TAAAAABJRU5ErkJggg=="
                // width={200}
                style={{ maxHeight: 150, }}
                src={url}
                prefix={`${url}?x-oss-process=image/blur,r_50,s_50/quality,q_1/resize,m_mfit,h_200,w_200`}
              />

            </>}
          >
            <Card.Meta
              description={filename}
            />
          </ImageContainer>
        </Image.PreviewGroup>
    );

  };

  const MultiUpload = () =>
    <Upload.Dragger
      // onChange={onChange}
      beforeUpload={beforeUpload}
      fileList={null}
      multiple={multiple}
    >

      <p className="ant-upload-drag-icon">
        <InboxOutlined />
      </p>
      <p className="ant-upload-text">Upload de fotos</p>
      <p className="ant-upload-hint">
        Clique ou arraste suas fotos para fazer o upload em massa.
      </p>
    </Upload.Dragger>

  const DragDropMultipleLine = () => <DragDropContext onDragEnd={handleOnDragEnd}>
    <Droppable
      key='Droppable'
      droppableId="Droppable"
      type="COLUMN"
      direction="horizontal"
      ignoreContainerClipping={true}
      isCombineEnabled={true}
    >
      {(providerDrop) => (
        <div key='parent-drop'
          style={{
            margin: '1rem',
            display: 'flex',
            direction: 'column',
            gap: '1rem',
            flexWrap: 'wrap',
            'justify-content': 'space-evenly',
          }} {...providerDrop.droppableProps} ref={providerDrop.innerRef}
        >
          {sortedFileList?.map((item, index) => <Draggable key={item?.url} draggableId={item?.url} index={index}>
            {(providerDrag) => (
              <div key={item.url} ref={providerDrag.innerRef}
                {...providerDrag.draggableProps}
                {...providerDrag.dragHandleProps}
              >
                <ListItem key={item.url} url={item.url} imageItem={item} />
              </div>
            )}

          </Draggable>
          )}
        </div>
      )}
    </Droppable>
  </DragDropContext>;

  const DragDrop = ({ isSimple = false }) => <DragDropContext onDragEnd={handleOnDragEnd}>
    <Droppable
      key='Droppable'
      droppableId="Droppable"
      ignoreContainerClipping={true}
      isCombineEnabled={true}
    >
      {(providerDrop) => (
        <div key='parent-drop'
          style={{ display: 'flex', gap: '1rem', flexDirection: 'column', alignItems: 'center', }}
          {...providerDrop.droppableProps} ref={providerDrop.innerRef}
        >
          {sortedFileList?.map((item, index) => <Draggable key={item?.url} draggableId={item?.url} index={index}>
            {(providerDrag) => (
              <div key={item.url} ref={providerDrag.innerRef}
                {...providerDrag.draggableProps}
                {...providerDrag.dragHandleProps}
              >
                <ListItem key={item.url} url={item.url} imageItem={item} isSimple={isSimple} />
              </div>
            )}

          </Draggable>
          )}
        </div>
      )}
    </Droppable>
  </DragDropContext>;

  const [visible, setVisible] = useState(false);
  const onClose = () => setVisible(false);

  const onSaveSort = () => {

    const handleSort = externalSortHandler
      ? externalSortHandler(sortedFileList)
      : api[method](`${uploadUrl}/order`, { gallery: sortedFileList });
    setLoading(true);
    handleSort
      .then(({ data }) => {
        notification.success({ message: `Ordenação alterada com sucesso!` });
        store.collection = transformHandler ? data.map(transformHandler) : data;
        store.order = store.collection.length;
        updateMap();
        handler(store.collection);
      })
      .catch((ex) => {
        notification.error({ message: `Falha ao tentar enviar ordenação!`, ex });
      })
      .finally(() => {
        setLoading(false);
        setVisible(false);
      });

  }
  const showDrawer = () => {
    setSortedFileList(fileList);
    setVisible(true);
  }
  const SortGallery = () => {

    return (<>
      <Button
        type="default"
        icon={<CaretUpOutlined />}
        onClick={showDrawer}
        style={{ position: 'fixed', right: '-4rem', top: '50%', transform: 'rotate(-90deg)', color: 'white', background: 'linear-gradient(90deg,#ea5c1e 0%,#c13818 100%)' }}
      >Alterar ordenação</Button>
      <Drawer
        title="Ordenação de fotos"
        placement="right"
        closable={false}
        onClose={() => { console.log('onClose') }}
        open={visible}
        forceRender
        extra={<CloseOutlined onClick={onClose} />}
        footer={
          <SaveButton onClick={onSaveSort} style={{ marginRight: 8 }}>Salvar ordenação</SaveButton>
        }
      >
        <DragDrop isSimple />
      </Drawer >
    </>);
    ;
  }

  const SimpleGallery = () =>
    <div key='parent-drop'
      style={{
        margin: '1rem',
        display: 'flex',
        direction: 'column',
        gap: '1rem',
        flexWrap: 'wrap',
        'justify-content': 'space-between',
      }}
    >
      {fileList?.map((item,) =>
        <ListItem key={item.url} url={item.url} imageItem={item} />
      )}
    </div>
  // {
  // return (<ImgCrop
  //   showGrid
  //   rotationSlider
  //   aspectSlider
  //   showReset
  //   modalTitle='Editar imagem'
  //   modalOk='Salvar'
  //   modalCancel='Cancelar'
  //   resetText='Desfazer'
  // >
  //   <Upload.Dragger
  //     onChange={onChange}
  //     beforeUpload={beforeUpload}
  //     fileList={null}
  //     multiple
  //   >
  //     <p className="ant-upload-drag-icon">
  //       <InboxOutlined />
  //     </p>
  //     <p className="ant-upload-text">Clique ou arraste suas fotos</p>
  //     <p className="ant-upload-hint">
  //       Faça o upload em massa ou envie uma foto para ser ajustada.
  //     </p>
  //   </Upload.Dragger>
  // </ImgCrop>);
  // };

  return (<>
    {loading && <Loading />}
    <SortGallery key={'sort'} />
    <MultiUpload key='MultiUpload' />
    <SimpleGallery key={'gallery'} />
  </>
  )
};

export default UploadGalley;